type PropertyLogoSource = {
  logo_url?: string | null;
  image?: Array<{ url?: string | null } | null> | null;
} | null | undefined;

/** Prefer media image, then logo_url, otherwise empty (caller shows PassTrack). */
export const getPropertyLogoUrl = (property: PropertyLogoSource): string => {
  const mediaUrl = property?.image?.[0]?.url?.trim();
  if (mediaUrl) return mediaUrl;

  const logoUrl = property?.logo_url?.trim();
  if (logoUrl) return logoUrl;

  return "";
};
